import React, { useState, useEffect, useRef } from 'react';
import { adsAPI } from '../../services/api';
import { ChevronLeft, ChevronRight } from 'lucide-react';

const ROTATE_MS = 5000;

// Rotating promo banner shown at the top of the customer app dashboard — active
// ads managed by staff/admin under Settings → AD. Renders nothing if there are
// none, so it's invisible until the business actually uploads something.
export default function AdBanner() {
  const [ads, setAds]     = useState([]);
  const [index, setIndex] = useState(0);
  const timer = useRef(null);

  useEffect(() => {
    adsAPI.getActive().then(r => setAds(r.data?.data || [])).catch(() => {});
  }, []);

  useEffect(() => {
    if (ads.length < 2) return;
    timer.current = setInterval(() => setIndex(i => (i + 1) % ads.length), ROTATE_MS);
    return () => clearInterval(timer.current);
  }, [ads.length]);

  if (ads.length === 0) return null;

  const goTo = (i) => setIndex(((i % ads.length) + ads.length) % ads.length);
  const ad = ads[index];

  const Frame = ad.linkUrl ? 'a' : 'div';
  const frameProps = ad.linkUrl ? { href: ad.linkUrl, target: '_blank', rel: 'noreferrer' } : {};

  return (
    <div style={{ position: 'relative', marginBottom: 22, borderRadius: 14, overflow: 'hidden', boxShadow: '0 4px 16px rgba(0,0,0,.08)' }}>
      <Frame {...frameProps} style={{ display: 'block', width: '100%', aspectRatio: '16/7', background: 'var(--cb-f3f4f6)' }}>
        <img src={ad.imageUrl} alt={ad.title || 'Offer'} style={{ width: '100%', height: '100%', objectFit: 'cover', display: 'block' }} />
      </Frame>

      {ad.title && (
        <div style={{
          position: 'absolute', left: 0, right: 0, bottom: 0, padding: '18px 16px 10px',
          background: 'linear-gradient(transparent, rgba(0,0,0,.55))', color: 'var(--c-ffffff)',
          fontSize: '.85rem', fontWeight: 600, pointerEvents: 'none',
        }}>
          {ad.title}
        </div>
      )}

      {ads.length > 1 && (
        <>
          <button onClick={() => goTo(index - 1)} aria-label="Previous"
            style={navBtnStyle('left')}>
            <ChevronLeft size={16} />
          </button>
          <button onClick={() => goTo(index + 1)} aria-label="Next"
            style={navBtnStyle('right')}>
            <ChevronRight size={16} />
          </button>
          <div style={{ position: 'absolute', bottom: 8, left: 0, right: 0, display: 'flex', justifyContent: 'center', gap: 6 }}>
            {ads.map((_, i) => (
              <button key={i} onClick={() => goTo(i)} aria-label={`Slide ${i + 1}`} style={{
                width: i === index ? 16 : 6, height: 6, borderRadius: 3, border: 'none',
                background: i === index ? 'var(--cb-ffffff)' : 'rgba(255,255,255,.5)', cursor: 'pointer', padding: 0, transition: 'width .2s',
              }} />
            ))}
          </div>
        </>
      )}
    </div>
  );
}

const navBtnStyle = (side) => ({
  position: 'absolute', top: '50%', [side]: 8, transform: 'translateY(-50%)',
  width: 30, height: 30, borderRadius: '50%', border: 'none', background: 'rgba(0,0,0,.35)',
  color: 'var(--c-ffffff)', display: 'flex', alignItems: 'center', justifyContent: 'center', cursor: 'pointer',
});
